export const DEFAULT_CURRENCY_EXPONENT = 2;
const CURRENCY_CODE_PATTERN = /^[A-Z]{3}$/;
/**
 * ISO 4217 minor-unit exponents that differ from the default of 2. Every other active code
 * uses 2, so keeping only the exceptions here means a new currency needs no edit unless it
 * is one of the unusual ones. Source: ISO 4217 table A.1.
 */
export const CURRENCY_EXPONENTS = {
    BIF: 0,
    CLP: 0,
    DJF: 0,
    GNF: 0,
    ISK: 0,
    JPY: 0,
    KMF: 0,
    KRW: 0,
    PYG: 0,
    RWF: 0,
    UGX: 0,
    UYI: 0,
    VND: 0,
    VUV: 0,
    XAF: 0,
    XOF: 0,
    XPF: 0,
    BHD: 3,
    IQD: 3,
    JOD: 3,
    KWD: 3,
    LYD: 3,
    OMR: 3,
    TND: 3,
    CLF: 4,
    UYW: 4,
};
export const assertCurrencyCode = (code) => {
    if (!CURRENCY_CODE_PATTERN.test(code)) {
        throw new RangeError(`Expected an uppercase ISO 4217 code, received "${code}"`);
    }
    return code;
};
export const currencyExponent = (code) => CURRENCY_EXPONENTS[assertCurrencyCode(code)] ?? DEFAULT_CURRENCY_EXPONENT;
export const minorUnitScale = (code) => 10 ** currencyExponent(code);
//# sourceMappingURL=currency-exponents.js.map